import {
  LocalStorageConsts,
  ViewportBannerConsts,
} from 'client/util/Constants';

const AndroidEmmSurveyBannerConfig = (user = {}) => ({
  name: 'AndroidEmmSurveyBanner',
  bannerText: 'We would appreciate your help! Take this brief survey to share your Android Device Management needs with us.',
  learnMoreLink: 'https://www.surveymonkey.com/r/android-banner',
  learnMoreText: 'Please take this brief survey.',
  bannerType: ViewportBannerConsts.types.info,
  localStorageKey: LocalStorageConsts.androidEmmSurveyBannerDismissed,
  startDate: '2022/12/05',
  endDate: '2022/12/11',
  bannerVisibility: () => !user.isCommandRunner,
});

export default AndroidEmmSurveyBannerConfig;
